import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import s from './PlainButtonOrLink.scss';
var PlainButtonOrLink = function (_a) {
    var className = _a.className, isFakeButton = _a.isFakeButton, _b = _a.onKeyDown, onKeyDown = _b === void 0 ? function () { return null; } : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { return null; } : _c, rest = __rest(_a, ["className", "isFakeButton", "onKeyDown", "onClick"]);
    var href = rest.href;
    var classNames = classnames(href ? s['link'] : s['button'], className);
    var props = __assign({ className: classNames }, rest);
    return href ? (React.createElement(BiLink, __assign({ onClick: onClick, onKeyDown: onKeyDown }, props))) : !isFakeButton ? (React.createElement(BiButton, __assign({ onClick: onClick, onKeyDown: onKeyDown }, props))) : (
    // There are some instances where we need to render a button inside of a button. This is not correct HTML.
    // To solve this use-case, the following is a fake button using role="button" and the correct event handlers.
    React.createElement(BiSpan, __assign({ tabIndex: 0, onClick: onClick, onKeyDown: function (e) {
            switch (e.key) {
                case 'Enter':
                case 'Space':
                case ' ':
                    onClick(e);
                    break;
                default:
                    break;
            }
            onKeyDown(e);
        } }, props)));
};
PlainButtonOrLink.displayName = 'PlainButtonOrLink';
export default PlainButtonOrLink;
//# sourceMappingURL=PlainButtonOrLink.js.map